/**
 * Floating Shapes - Scroll-driven float up
 * Reveal handled by scrollReveal.js (js-reveal class)
 * Parallax movement powered by Lenis
 * Shapes fade out when scroll stops, fade in when scrolling
 */
import lenis from "./smoothScroll.js";

(function () {
  var section = document.querySelector('.floating-shapes');
  if (!section) return;

  var items = section.querySelectorAll('.floating-shapes__item');
  var speeds = [];
  var baseTransforms = [];
  var hideTimer = null;

  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    var speed;

    if (item.classList.contains('floating-shapes__oval')) {
      speed = 1.8 + Math.random() * 0.5;
    } else {
      speed = 0.5 + Math.random() * 1.2;
    }

    speeds.push(speed);
    baseTransforms.push(
      item.classList.contains('floating-shapes__green-flower')
        ? 'translate(-50%, -50%) '
        : ''
    );
  }

  function showShapes() {
    section.classList.add('is-scrolling');
  }

  function hideShapes() {
    section.classList.remove('is-scrolling');
  }

  function update() {
    if (!section.classList.contains('is-visible')) return;

    // Show shapes on scroll
    showShapes();
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideShapes, 600);

    var rect = section.getBoundingClientRect();
    var sectionH = section.offsetHeight;
    var progress = Math.max(0, Math.min(1, (window.innerHeight - rect.top) / (window.innerHeight + sectionH)));

    for (var i = 0; i < items.length; i++) {
      var y = progress * speeds[i] * window.innerHeight * -1;
      items[i].style.transform = baseTransforms[i] + 'translateY(' + y + 'px)';
    }
  }

  lenis.on('scroll', update);
})();
